<template>
	<div class="tabWrapperSettings statementsItems">

		<main-table-all-back
				:flag="flag"
				page-title="Versions"
				:headers="getHeaders"
				:filtersList="settingVersionsFilters"
				:list="settingVersionsListRows"
				:defaultOrder="settingVersionsListOrder"
				:defaultSort="settingVersionsListSort"

				:totals="settingVersionsListTotals"
				:total-pages="settingVersionsListTotal"
				:limit-pages="settingVersionsListLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateCreate="onCreate"
				text-create="Add new version"
				:isExport="false"
				is-create
				:is-settings="false"
		></main-table-all-back>

		<preload v-if="isPreloader"></preload>

		<view-version
				v-if="isViewVersion"
				:dialogFlag="dialogFlag"
				:lastVersion="lastVersion"
				@updateSave="onSaveViewVersion"
				@updateClose="onCloseDialog('isViewVersion')"
				@updateList="onUpdateList()"
		></view-version>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

	</div>
</template>

<script>

import { mapActions, mapGetters } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";

// import { PERMISSIONS } from "@/constants/constants";
import { settingTabVersions } from "@/pages/Account/constants";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import ViewVersion from "@/components/Settings/UserAccountSettings/ViewVersion/ViewVersion.vue";
import { TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";

export default {
	name: "TabVersions",
	components: {
		ViewVersion,
		DialogRemove,
		MainTableAllBack,
		Preload,
	},
	props: {
		id: Number,
		isGeneralTitle: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		...mapGetters([
			"settingVersionsListRows",
			"settingVersionsListLimit",
			"settingVersionsListOrder",
			"settingVersionsListSort",
			"settingVersionsListTotal",
			"settingVersionsFilters",
			"settingVersionsListTotals",
		]),
		getHeaders() {
			return settingTabVersions;
		},

	},
	data: () => ({
		flag: 'TabVersions',
		isPreloader: false,
		isViewVersion: false,
		defaultFilter: null,
		start: false,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
		dialogFlag: null,
		lastVersion: null,
	}),

	methods: {
		...mapActions([
			'getSettingVersionsList',
			'getSettingVersionsListFilter',
			'deleteSettingVersions',
			'getSettingVersionsEdit',
		]),
		onClickButton({ key, item }) {
			this.activeItem = item;

			if ( key === 'edit1' ) {
				this.tabVersionEdit();
			}
			if ( key === 'delete1' ) {
				const title = TITLE.REMOVE_VERSION;
				const text = TEXT.REMOVE_VERSION;
				this.onRemoveDialog({ title, text });
			}
		},

		async tabVersionEdit() {
			this.dialogFlag = 'edit';
			const { id } = this.activeItem;
			await this.getSettingVersionsEdit(id);
			this.isViewVersion = true;
		},
		onCreate() {
			this.dialogFlag = 'add';
			this.isViewVersion = true;
		},

		async onUpdateFilters(filters, isWithoutPayload, isWithoutFilters) {
			if (!isWithoutPayload) this.isPreloader = true;
			await this.getSettingVersionsList(filters);
			if (!isWithoutFilters) await this.getSettingVersionsListFilter(filters);
			if (!isWithoutPayload) this.isPreloader = false;
			this.updatelastVersion();

		},

		async onList(values) {
			this.isPreloader = true;
			const { value, flag } = values;
			this.defaultFilter = value;

			switch (flag) {
				case "sorting":
					await this.getSettingVersionsList(value);
					this.isPreloader = false;
					this.updatelastVersion();
					break;
				case "page":
					await this.onUpdateFilters(value, 1, 1);
					this.isPreloader = false;
					break;
				default:

					if (this.start) {
						await this.onUpdateFilters(value, 1);
					} else {
						const filters = { id: this.id };

						await this.onUpdateFilters(filters, 1);
						this.start = true;
					}
					this.isPreloader = false;

			}
		},

		setNewItem(e, id, name) {
			this.$emit('updateNewItem', { e, id, name });
		},

		async onRemove() {
			const { id } = this.activeItem;
			await this.deleteSettingVersions(id);
			this.onCloseRemove();
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

		async onUpdateList() {
			await this.getSettingVersionsList();
			this.updatelastVersion();
		},
		onSaveViewVersion(args) {
			console.info('%c [ onSaveViewDepartments args  ] ', 'color:#bada55', typeof args, args);
		},
		onCloseDialog(key) {
			this[key] = false;
		},
		updatelastVersion() {
			this.lastVersion = this.settingVersionsListRows.reduce((latestRow, currentRow) =>
				new Date(currentRow.date) > new Date(latestRow.date) ? currentRow : latestRow
			);
		}

	},
};
</script>

<style scoped lang="scss">
@import "tabWrapperSettings";
.statementsItems {
	padding: 0;
}

</style>
